import LoginCharacterImage from '@/assets/login-character.png';
import { LanguageSwitcher } from '@/components/LanguageSwitcher/LanguageSwitcher';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthBackButton } from './AuthBackButton';
import { AuthRouteTransition } from './AuthRouteTransition';

const LOGIN_CHARACTER_APPEARANCE_RATE = 0.05;

export const AuthExperienceLayout = () => {
  const { t } = useTranslation();
  const [showLoginCharacter] = useState(
    () => Math.random() < LOGIN_CHARACTER_APPEARANCE_RATE
  );
  const policyLinks = [
    { label: t('利用規約'), href: t('terms-and-conditions-url') },
    { label: t('プライバシーポリシー'), href: t('privacy-policy-url') },
    { label: t('データポリシー'), href: t('data-policy-url') },
  ];

  return (
    <div
      data-auth-experience-shell
      className="relative min-h-screen overflow-hidden bg-rw-black"
    >
      <div
        data-auth-experience-background
        className="absolute inset-0 hidden overflow-hidden lg:block"
      >
        <img
          src="/images/login-background.webp"
          alt=""
          className="size-full object-cover object-right-bottom opacity-50"
        />
      </div>

      <main className="relative z-10 flex min-h-screen w-full">
        <section
          data-auth-experience-panel
          className="relative flex min-h-screen w-full flex-col justify-between bg-white p-6 shadow-[0_10px_24px_#BAC7CC] sm:p-9 lg:w-[528px] lg:shrink-0 lg:rounded-tr-[48px]"
        >
          <div
            data-auth-experience-navigation
            className="flex min-h-8 items-center justify-between"
          >
            <div data-auth-back-slot>
              <AuthBackButton />
            </div>
            <LanguageSwitcher variant="login" />
          </div>

          <div className="w-full">
            <AuthRouteTransition />
          </div>

          <div className="flex flex-wrap items-center justify-center text-sm leading-[21px] text-rw-neutral-gray">
            {policyLinks.map(({ href, label }, index) => (
              <React.Fragment key={label}>
                {index > 0 && <span aria-hidden="true">・</span>}
                <a
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-rw-neutral-darker-gray"
                >
                  {label}
                </a>
              </React.Fragment>
            ))}
          </div>
        </section>

        {showLoginCharacter && (
          <img
            src={LoginCharacterImage}
            alt=""
            className="pointer-events-none absolute bottom-0 left-[552px] hidden h-[209px] w-[157px] object-contain lg:block"
          />
        )}
      </main>
    </div>
  );
};
